// Module
var code = "<a> <span ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span> <span ng-if=\"match.model.ParentVendorShortName || match.model.ParentVendorName\"><br/>Parent: {{match.model.ParentVendorShortName}} - {{match.model.ParentVendorName}}</span> </a> ";
// Exports
module.exports = code;